(function () {
    'use strict';

    angular
        .module('jcsfApp')
        .factory('authenticate', authenticate);

    authenticate.$inject = ['$timeout', '$http','$location', 'messaging', 'events', 'modelTransformer', 'User', '$cookieStore'];
    function authenticate($timeout, $http, $location,messaging, events, modelTransformer, User, $cookieStore) {
        var currentUser = {};
        function login(data) {
            data.password = data.pw;
            $http.post('/api/auth/logon', data).then(loginUserSuccessHandler, authenticationFailureHandler);
        }
        function loginUserSuccessHandler(results) { 
           $http.defaults.headers.common.Authorization = "Bearer " + results.data.access_token; 
            if (!results  || !results.data || !results.data.userName) {
                authenticationFailureHandler(results);
            }else{currentUser = results.data.userName;}
            getUserInfo(currentUser);
        }
        function getUserInfo(user) {
            $http.get('/api/user/Get/'+user)
            .then(getLoggedInUserSuccessHandler, authenticationFailureHandler);
        }
        function getLoggedInUserSuccessHandler(results) {
            currentUser = (modelTransformer.transform(results.data, User)); 
            $cookieStore.put('user', currentUser);
            messaging.publish(events.message._AUTHENTICATE_USER_COMPLETE_, [currentUser]);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_); 
        }
        function authenticationFailureHandler(results) { 
                     messaging.publish(events.message._AUTHENTICATE_USER_FAILED_);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            messaging.publish(events.message._ADD_ERROR_MESSAGE_, ['Log In Failed. ' + results.data.message , 'alert-danger']);
        }
        function registerUser(user) {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post('/api/Account/Register',user).then(onRegisterComplete);
            
        }
        function currentUserHandler() { 
            if (!currentUser || !currentUser.length) {
                var user = $cookieStore.get('user');
                if (user) { 
                    currentUser = user;
                    currentUser.fullName = currentUser.LastName + ', ' + currentUser.FirstName;
                }
            } 
            messaging.publish(events.message._CURRENT_USER_RESPONSE_, [currentUser]); 
          }
        function logout() {
            messaging.publish(events.message._SERVER_REQUEST_STARTED_);
            $http.post('/api/Account/Logout').then(onLogOutComplete);
        }
        function init() {
            
        }
        function onRegisterComplete() {
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
            messaging.publish(events.message._REGISTER_USER_COMPLETE_, []);
            
        }
        function onLogOutComplete() { 
            $cookieStore.remove('_Token'); 
            $cookieStore.remove('user');
            currentUser = ''; 
            messaging.publish(events.message._USER_LOGOUT_COMPLETE_, [true]);
            messaging.publish(events.message._SERVER_REQUEST_ENDED_);
        }
        var authenticateOut = {
            init: init,
            currentUserHandler:currentUserHandler
        };
        messaging.subscribe(events.message._LOGIN_FAILED_, authenticationFailureHandler);
        messaging.subscribe(events.message._AUTHENTICATE_USER_, login);
        messaging.subscribe(events.message._USER_LOGOUT_, logout);
        messaging.subscribe(events.message._REQUEST_CURRENT_USER_, currentUserHandler);
        messaging.subscribe(events.message._REGISTER_USER_, registerUser);

        return authenticateOut;
    }
})();